import { __assign } from "tslib";
import React from "react";
import { noop } from "../../../_util/noop";
import { DraggableTable, DraggableTableBody } from "./DraggableTable";
export function columnsDraggable(_a) {
    var _b = _a.onDragEnd, onDragEnd = _b === void 0 ? noop : _b, _c = _a.draggableColumns, draggableColumns = _c === void 0 ? "all" : _c;
    return {
        onInjectProps: function (props) {
            return __assign(__assign({}, props), { columnsDraggable: true, draggableColumns: draggableColumns });
        },
        onInjectTable: function (render) { return function (props) {
            var table = render(props);
            var columns = props.columns;
            var newColumns = columns.filter(function (column) { return !column.ignore; });
            return (React.createElement(DraggableTable, { table: table, draggableColumns: draggableColumns, onDragEnd: onDragEnd, columns: newColumns }));
        }; },
        onInjectBody: function (render) { return function (records, columns, topTip, bottomTip) {
            var body = render(records, columns, topTip, bottomTip);
            return (React.createElement(DraggableTableBody, { body: body, onDragEnd: onDragEnd, draggableColumns: draggableColumns }));
        }; },
    };
}
//# sourceMappingURL=columnsDraggable.js.map